import { GPTGameIcon } from 'src/EXPERIMENTAL_LIB/gpt/icons';

export const WheelOfFortuneEventIcon: GPTGameIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}>
    <g clipPath="url(#clip0_3460_1061)">
      <path
        d="M11.6 23.05C17.94 23.05 23.09 17.91 23.09 11.56C23.09 5.21 17.94 0.0800018 11.6 0.0800018C5.25999 0.0800018 0.109985 5.22 0.109985 11.56C0.109985 17.9 5.24999 23.05 11.6 23.05Z"
        fill="#A15EFF"
      />
      <path
        d="M11.6 22.83C17.82 22.83 22.86 17.79 22.86 11.57C22.86 5.35 17.82 0.300003 11.6 0.300003C5.37999 0.300003 0.329987 5.34 0.329987 11.56C0.329987 17.78 5.36999 22.82 11.59 22.82L11.6 22.83Z"
        fill="#8935FF"
      />
      <path
        d="M11.6 21.7C17.2 21.7 21.74 17.16 21.74 11.56C21.74 5.96 17.2 1.42 11.6 1.42C5.99999 1.42 1.45999 5.96 1.45999 11.56C1.45999 17.16 5.99999 21.7 11.6 21.7Z"
        fill="#742DD9"
      />
      <path
        d="M20.98 9.05C20.55 7.46 19.72 5.95 18.47 4.7L11.6 11.57L20.98 9.06V9.05Z"
        fill="#F8203D"
      />
      <path
        d="M11.6 11.56L20.98 14.07C21.42 12.42 21.42 10.69 20.98 9.03999L11.6 11.55V11.56Z"
        fill="white"
      />
      <path
        d="M11.6 11.56L18.47 4.68999C17.22 3.43999 15.71 2.59999 14.12 2.17999L11.61 11.56H11.6Z"
        fill="white"
      />
      <path
        d="M11.6 11.56L9.09 20.94C10.74 21.38 12.47 21.38 14.12 20.94L11.61 11.56H11.6Z"
        fill="#F8203D"
      />
      <path
        d="M14.11 20.94C15.7 20.51 17.21 19.68 18.46 18.43L11.59 11.56L14.1 20.94H14.11Z"
        fill="white"
      />
      <path
        d="M4.73 18.43C5.98 19.68 7.49 20.52 9.08 20.94L11.59 11.56L4.72 18.43H4.73Z"
        fill="white"
      />
      <path
        d="M11.6 11.56L18.47 18.43C19.72 17.18 20.56 15.67 20.98 14.08L11.6 11.57V11.56Z"
        fill="#F8203D"
      />
      <path
        d="M11.6 11.56L2.22001 9.05C1.78001 10.7 1.78001 12.43 2.22001 14.08L11.6 11.57V11.56Z"
        fill="white"
      />
      <path
        d="M11.6 11.56L9.08999 2.17999C7.49999 2.60999 5.98999 3.43999 4.73999 4.68999L11.61 11.56H11.6Z"
        fill="white"
      />
      <path
        d="M4.73 4.68999C3.48 5.93999 2.64 7.44999 2.22 9.03999L11.6 11.55L4.73 4.67999V4.68999Z"
        fill="#F8203D"
      />
      <path
        d="M11.6 11.56L2.22 14.07C2.65 15.66 3.48 17.17 4.73 18.42L11.6 11.55V11.56Z"
        fill="#F8203D"
      />
      <path
        d="M14.11 2.18001C12.46 1.74001 10.73 1.74001 9.08 2.18001L11.59 11.56L14.1 2.18001H14.11Z"
        fill="#F8203D"
      />
      <path
        d="M11.94 1.06999C11.99 0.879994 11.88 0.679994 11.69 0.629994C11.5 0.579994 11.3 0.689994 11.25 0.879994C11.2 1.06999 11.31 1.26999 11.5 1.31999C11.69 1.36999 11.89 1.25999 11.94 1.06999Z"
        fill="white"
      />
      <path
        d="M11.6 22.5C11.8 22.5 11.96 22.34 11.96 22.14C11.96 21.94 11.8 21.78 11.6 21.78C11.4 21.78 11.24 21.94 11.24 22.14C11.24 22.34 11.4 22.5 11.6 22.5Z"
        fill="white"
      />
      <path
        d="M6.60999 2.22C6.70999 2.39 6.64999 2.61 6.47999 2.71C6.30999 2.81 6.08999 2.75 5.98999 2.58C5.88999 2.41 5.94999 2.19 6.11999 2.09C6.28999 1.99 6.50999 2.05 6.60999 2.22Z"
        fill="white"
      />
      <path
        d="M17.2 20.55C17.3 20.72 17.24 20.94 17.07 21.04C16.9 21.14 16.68 21.08 16.58 20.91C16.48 20.74 16.54 20.52 16.71 20.42C16.88 20.32 17.1 20.38 17.2 20.55Z"
        fill="white"
      />
      <path
        d="M2.61 5.95999C2.78 6.05999 2.84 6.27999 2.74 6.44999C2.64 6.61999 2.42 6.67999 2.25 6.57999C2.08 6.47999 2.02 6.25999 2.12 6.08999C2.22 5.91999 2.44 5.85999 2.61 5.95999Z"
        fill="white"
      />
      <path
        d="M20.76 17.21C20.96 17.21 21.12 17.05 21.12 16.85C21.12 16.65 20.96 16.49 20.76 16.49C20.56 16.49 20.4 16.65 20.4 16.85C20.4 17.05 20.56 17.21 20.76 17.21Z"
        fill="white"
      />
      <path
        d="M1.35998 11.64C1.40998 11.45 1.28998 11.26 1.08998 11.21C0.899985 11.16 0.709985 11.28 0.659985 11.48C0.609985 11.67 0.729985 11.86 0.929985 11.91C1.11998 11.96 1.30998 11.84 1.35998 11.64Z"
        fill="white"
      />
      <path
        d="M22.44 11.81C22.58 11.67 22.58 11.44 22.44 11.31C22.3 11.17 22.07 11.17 21.94 11.31C21.8 11.45 21.8 11.68 21.94 11.81C22.08 11.95 22.31 11.95 22.44 11.81Z"
        fill="white"
      />
      <path
        d="M2.43001 17.21C2.63001 17.21 2.79001 17.05 2.79001 16.85C2.79001 16.65 2.63001 16.49 2.43001 16.49C2.23001 16.49 2.07001 16.65 2.07001 16.85C2.07001 17.05 2.23001 17.21 2.43001 17.21Z"
        fill="white"
      />
      <path
        d="M20.59 5.95999C20.76 5.85999 20.98 5.91999 21.08 6.08999C21.18 6.25999 21.12 6.47999 20.95 6.57999C20.78 6.67999 20.56 6.61999 20.46 6.44999C20.36 6.27999 20.42 6.05999 20.59 5.95999Z"
        fill="white"
      />
      <path
        d="M6 20.55C6.1 20.38 6.32 20.32 6.49 20.42C6.66 20.52 6.72 20.74 6.62 20.91C6.52 21.08 6.3 21.14 6.13 21.04C5.96 20.94 5.9 20.72 6 20.55Z"
        fill="white"
      />
      <path
        d="M16.94 2.75C17.14 2.72 17.27 2.54 17.25 2.35C17.22 2.15 17.04 2.02 16.85 2.04C16.65 2.07 16.52 2.25 16.54 2.44C16.57 2.64 16.75 2.77 16.94 2.75Z"
        fill="white"
      />
      <path
        d="M13.93 11.65C13.93 12.82 12.98 13.77 11.81 13.77C10.64 13.77 9.69 12.82 9.69 11.65C9.69 10.48 11.81 6.77 11.81 6.77C11.81 6.77 13.93 10.47 13.93 11.65Z"
        fill="#742DD9"
      />
      <path
        d="M12.85 11.75C12.94 11.17 12.55 10.63 11.98 10.54C11.4 10.45 10.86 10.84 10.77 11.41C10.68 11.99 11.07 12.53 11.64 12.62C12.22 12.71 12.76 12.32 12.85 11.75Z"
        fill="white"
      />
      <path
        opacity={0.15}
        d="M2.95001 12.46C2.95001 7.10001 7.29001 2.75001 12.66 2.75001C14.81 2.75001 16.79 3.45001 18.4 4.63001C16.65 2.91001 14.25 1.85001 11.6 1.85001C6.23001 1.85001 1.89001 6.20001 1.89001 11.56C1.89001 14.77 3.45001 17.62 5.86001 19.39C4.07001 17.63 2.95001 15.17 2.95001 12.46Z"
        fill="black"
      />
      <path
        d="M23.11 21.4C24.74 18.78 23.89 15.3 21.21 13.63C18.53 11.96 15.04 12.73 13.4 15.36C11.76 17.99 12.62 21.46 15.3 23.13C17.98 24.8 21.47 24.03 23.11 21.4Z"
        fill="url(#paint0_radial_3460_1061)"
      />
      <mask
        id="mask0_3460_1061"
        style={{
          maskType: 'luminance'
        }}
        maskUnits="userSpaceOnUse"
        x={12}
        y={12}
        width={12}
        height={13}>
        <path
          d="M23.11 21.4C24.74 18.78 23.89 15.3 21.21 13.63C18.53 11.96 15.04 12.73 13.4 15.36C11.76 17.99 12.62 21.46 15.3 23.13C17.98 24.8 21.47 24.03 23.11 21.4Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_3460_1061)">
        <path
          d="M20.72 12.43C18.24 10.71 14.81 11.34 13.06 13.83C11.31 16.33 11.9 19.75 14.38 21.47C16.86 23.19 20.29 22.56 22.04 20.07C23.79 17.57 23.2 14.15 20.72 12.43Z"
          fill="url(#paint1_radial_3460_1061)"
        />
      </g>
      <path
        d="M21.01 22.24C20.67 22.74 20.23 23.13 19.69 23.41C19.66 23.43 19.62 23.47 19.59 23.51L19.68 23.69C19.61 23.63 19.3 23.72 19.19 23.71L19.28 23.67L19.16 23.62C19.08 23.64 18.96 23.64 18.89 23.67C18.79 23.72 18.74 23.69 18.64 23.69C18.28 23.68 17.92 23.68 17.56 23.63C17.39 23.61 17.21 23.54 17.04 23.55C16.85 23.56 16.68 23.63 16.48 23.59C16.11 23.52 15.75 23.34 15.4 23.16C14.79 22.85 14.24 22.36 13.8 21.83C13.47 21.43 13.18 21 13.02 20.5C13.27 21.05 13.56 21.54 13.98 21.98C14.24 22.26 14.49 22.53 14.81 22.74C15.35 23.1 15.78 23.36 16.41 23.53C16.61 23.59 16.82 23.54 17.02 23.5C17.19 23.47 17.36 23.42 17.45 23.29C17.39 23.31 17.34 23.33 17.31 23.33C17.31 23.29 17.32 23.25 17.31 23.24L17.21 23.18H17.29C17.06 22.86 16.84 22.62 16.7 22.24C16.68 22.19 16.67 22.14 16.62 22.13C16.02 21.92 15.34 21.47 14.87 21.04C14.55 21.04 14.23 21.08 13.91 21.04C13.78 21.17 13.92 21.65 13.95 21.81C13.86 21.64 13.76 21.48 13.64 21.33C13.27 20.86 12.94 20.04 12.84 19.45C12.84 19.34 12.87 19.23 12.89 19.12C12.98 19.74 13.39 20.45 13.8 20.93C13.86 21 13.92 21.03 14 21.03C14.22 21.03 14.43 21.03 14.65 21.03C14.72 21.03 14.79 21.03 14.86 21C14.8 20.51 14.79 20.02 14.9 19.55L15.02 19.03L14.89 18.8C14.81 18.67 14.73 18.54 14.69 18.39L15.04 19C15.04 19 15.11 19.04 15.13 19.04C15.72 19.01 16.32 19 16.92 19.01C17.04 19.01 17.05 18.97 17.1 18.88L17.3 18.52C17.5 18.16 17.72 17.82 17.95 17.48C18.03 17.37 18.1 17.27 18.16 17.15C17.84 16.56 17.58 15.97 17.34 15.36L17.2 15.32C17.27 15.31 17.35 15.33 17.4 15.28C17.86 14.84 18.4 14.43 19.01 14.2C18.93 13.92 18.79 13.66 18.62 13.41C18.58 13.35 18.54 13.26 18.46 13.24C17.76 13.05 17.05 13.07 16.37 13.27L16.34 13.18C17.01 13 17.5 12.87 18.19 12.88C18.44 12.88 18.68 12.92 18.93 12.95C19.16 12.98 19.21 12.9 19.39 12.93C19.09 13 18.98 12.97 18.69 13.12C18.63 13.15 18.55 13.22 18.55 13.29C18.74 13.56 18.91 13.82 19 14.14C19 14.17 19.05 14.21 19.08 14.22C19.81 14.43 20.24 14.7 20.84 15.16C21.46 15.1 21.69 15.16 22.3 15.34C22.34 15.03 22.3 14.67 22.11 14.41C21.83 14.03 21.16 13.61 20.75 13.38C20.37 13.16 19.96 13.04 19.54 12.93C19.38 12.89 19.23 12.84 19.05 12.82C18.58 12.74 18.13 12.74 17.65 12.76C18.02 12.69 18.38 12.72 18.76 12.76C19.41 12.82 20.26 13.08 20.84 13.39C21.38 13.69 21.74 13.96 22.18 14.4C22.65 14.88 22.96 15.22 23.28 15.81C23.44 16.11 23.58 16.42 23.67 16.75C23.74 16.97 23.85 17.43 23.89 17.65C24.02 18.34 24 19.02 23.83 19.7C23.74 20.08 23.63 20.44 23.45 20.78L23.32 21.03L23.2 21.24C22.41 22.61 21.15 23.5 19.59 23.83C18.96 23.96 18.33 24.01 17.68 23.92C17.35 23.87 17.05 23.81 16.74 23.7C16.66 23.67 16.57 23.67 16.5 23.61C16.66 23.65 16.79 23.69 16.94 23.73C17.55 23.91 18.08 23.95 18.7 23.92C19.03 23.91 19.33 23.84 19.64 23.78C20.4 23.62 21.09 23.31 21.71 22.85C22.07 22.59 22.39 22.3 22.66 21.94L22.86 21.68C22.94 21.57 23.01 21.46 23.07 21.33C23.01 21.41 22.59 21.15 22.59 21.15C22.15 21.62 21.62 21.98 21 22.22L21.01 22.24ZM16.14 19.4C16.2 19.35 16.26 19.4 16.3 19.44C16.37 19.5 16.46 19.42 16.49 19.37C16.49 19.37 16.54 19.39 16.54 19.38V19.33L16.68 19.34L16.54 19.27H16.82L17.11 19.72C17.14 19.64 17.03 19.64 17.07 19.56L17.16 19.7C17.16 19.7 17.14 19.61 17.13 19.58L16.89 19.11C16.35 19.07 15.83 19.07 15.3 19.13C15.23 19.13 15.12 19.17 15.09 19.21C15.02 19.37 14.99 19.52 14.96 19.68L15.01 19.64V19.81C15.08 19.66 15.07 19.51 15.17 19.39C15.25 19.3 15.41 19.28 15.51 19.28C15.51 19.3 15.51 19.33 15.51 19.32C15.51 19.32 15.48 19.31 15.47 19.31H15.41V19.37C15.43 19.37 15.47 19.37 15.48 19.38L15.54 19.45L15.51 19.34C15.58 19.44 15.64 19.47 15.76 19.47C15.99 19.47 16.04 19.21 16.13 19.27C16.09 19.3 16.06 19.33 16.03 19.37C16.02 19.39 16.05 19.45 16.07 19.44C16.08 19.44 16.1 19.42 16.13 19.39L16.14 19.4ZM18.03 16.38C18.12 16.41 18.18 16.44 18.23 16.41C18.28 16.38 18.29 16.31 18.28 16.26C18.26 16.18 18.2 16.14 18.13 16.15C18.02 16.2 18.05 16.29 18.04 16.4C17.91 16.13 17.77 15.87 17.7 15.59C17.64 15.35 17.82 15.15 17.97 14.98C17.8 15.06 17.64 15.19 17.52 15.36C17.52 15.44 17.54 15.54 17.57 15.63C17.74 16.12 17.95 16.58 18.21 17.04C18.32 17.06 18.42 17.06 18.52 17.06C18.26 16.91 18.15 16.63 18.03 16.38ZM20.74 22.54L20.95 22.27L20.22 20.98C19.93 20.98 19.66 21.08 19.37 21.03L19.87 20.99L20.14 20.95C20.14 20.95 20.23 20.85 20.28 20.78C20.66 20.23 21.01 19.67 21.3 19.06C21.06 18.43 20.73 17.84 20.34 17.26L19.48 17.23H18.17C18.09 17.3 18.03 17.39 17.97 17.49C17.92 17.57 17.86 17.64 17.81 17.72C17.69 17.89 17.59 18.07 17.48 18.25L17.14 18.83C17.11 18.89 17.08 18.95 17.05 19.01C17.37 19.65 17.7 20.27 18.06 20.91C18.5 20.99 18.92 21 19.37 21.03C19.06 21.06 18.75 21.03 18.44 20.99L18.05 20.95C17.63 21.41 17.21 21.81 16.68 22.14C16.85 22.61 17.11 22.94 17.45 23.29C18.08 23.52 18.92 23.56 19.55 23.4C19.91 23.31 20.49 22.84 20.73 22.53L20.74 22.54ZM22.82 19.18C23.01 18.85 23.1 18.53 23.2 18.18C23.27 17.84 23.33 17.49 23.26 17.14C23.13 16.46 22.76 15.85 22.27 15.37C21.79 15.2 21.34 15.12 20.85 15.18C20.86 15.53 20.81 15.86 20.73 16.19C20.64 16.53 20.53 16.84 20.39 17.16C20.37 17.2 20.37 17.26 20.39 17.29L20.66 17.74C20.91 18.15 21.11 18.56 21.29 19.02L22.8 19.17L22.82 19.18ZM23.47 16.79C23.52 16.89 23.57 16.97 23.61 17.08L23.75 17.14C23.61 16.49 23.35 15.91 22.98 15.36C22.76 15.03 22.49 14.75 22.22 14.47C22.27 14.61 22.31 14.72 22.34 14.85C22.65 15.21 22.94 15.59 23.16 16.01L23.29 16.26C23.29 16.26 23.45 16.71 23.49 16.8L23.47 16.79ZM21.1 19.84C21.2 19.67 21.27 19.53 21.33 19.36L21.19 19.59L21.31 19.28L20.91 19.98C20.74 20.28 20.55 20.55 20.36 20.84C20.34 20.86 20.34 20.93 20.36 20.96C20.38 20.98 20.44 21 20.46 21.01C20.46 20.99 20.43 20.95 20.44 20.93L20.67 20.56C20.69 20.62 21.03 19.98 21.11 19.85L21.1 19.84ZM23.35 20.92C23.7 20.28 23.89 19.55 23.94 18.83C23.98 18.29 23.91 17.71 23.76 17.19C23.65 17.13 23.54 17.08 23.42 17.06C23.37 17.06 23.33 17.12 23.33 17.17C23.35 17.7 23.3 18.24 23.09 18.72L22.85 19.26C22.92 19.9 22.85 20.51 22.63 21.11C22.76 21.19 22.9 21.24 23.03 21.27C23.12 21.29 23.18 21.24 23.22 21.17L23.36 20.92H23.35Z"
        fill="black"
      />
      <path
        d="M16.24 13.16C15.62 13.36 15.07 13.69 14.57 14.09C14.26 14.34 14 14.61 13.75 14.91C13.59 15.11 13.35 15.5 13.21 15.73C12.95 16.18 12.63 17.27 12.61 17.8L12.58 18.49C12.5 17.63 12.79 16.48 13.18 15.74L13.27 15.57C13.34 15.45 13.41 15.32 13.49 15.21L13.65 15C14.24 14.19 15.08 13.58 16.02 13.21C16.11 13.17 16.19 13.15 16.28 13.11C16.54 12.99 16.8 12.9 17.08 12.84C17.12 12.84 17.15 12.8 17.2 12.82C17.09 12.87 16.98 12.88 16.86 12.92C16.7 12.96 16.53 13.02 16.38 13.09C16.34 13.11 16.32 13.13 16.26 13.15L16.24 13.16Z"
        fill="black"
      />
      <path
        d="M15.26 15.45C14.84 15.93 14.5 16.45 14.28 17.05C14.24 17.16 14.24 17.25 14.27 17.35L14.21 17.23C13.83 17.3 13.47 17.39 13.11 17.54C13.06 17.43 13.05 17.32 13.05 17.2C13.05 16.65 13.17 16.13 13.4 15.64C13.45 15.53 13.5 15.42 13.58 15.33C13.93 14.9 14.47 14.42 15.02 14.22L15.06 14.5C15.11 14.82 15.16 15.13 15.27 15.46L15.26 15.45ZM14.77 15.83C14.77 15.83 14.71 15.87 14.68 15.89L14.91 15.5L14.74 15.74C14.53 16.02 14.35 16.31 14.18 16.62C13.98 17 13.93 16.92 13.54 17.06H13.7C13.7 17.06 13.72 17.13 13.71 17.14L13.56 17.22L13.94 17.13C14 17.12 14.08 17.1 14.13 17.07C14.3 16.62 14.52 16.23 14.77 15.83Z"
        fill="black"
      />
      <path
        d="M16.14 19.4C16.14 19.4 16.1 19.44 16.08 19.44C16.06 19.44 16.03 19.39 16.04 19.37C16.06 19.33 16.1 19.3 16.14 19.27C16.06 19.22 16 19.48 15.77 19.47C15.66 19.47 15.6 19.44 15.52 19.34L15.55 19.45L15.49 19.38C15.49 19.38 15.44 19.38 15.42 19.37C15.41 19.37 15.4 19.32 15.42 19.32H15.48C15.48 19.32 15.51 19.32 15.52 19.32C15.52 19.32 15.52 19.3 15.52 19.28C15.41 19.28 15.25 19.3 15.18 19.39C15.08 19.51 15.09 19.66 15.01 19.81V19.64L14.97 19.68C15 19.52 15.04 19.37 15.1 19.21C15.14 19.17 15.25 19.14 15.31 19.13C15.84 19.07 16.36 19.07 16.9 19.11L17.14 19.58C17.14 19.58 17.16 19.65 17.17 19.7L17.08 19.56C17.04 19.63 17.15 19.64 17.12 19.72L16.83 19.29L16.55 19.27L16.69 19.34H16.55V19.38C16.55 19.39 16.51 19.37 16.5 19.37C16.47 19.42 16.38 19.49 16.31 19.44C16.27 19.41 16.21 19.35 16.15 19.4H16.14Z"
        fill="white"
      />
      <path
        d="M18.03 16.38C18.15 16.63 18.26 16.91 18.52 17.06C18.42 17.06 18.32 17.06 18.21 17.04C17.94 16.58 17.73 16.12 17.57 15.63C17.54 15.55 17.52 15.44 17.52 15.36C17.64 15.19 17.79 15.06 17.97 14.98C17.82 15.14 17.64 15.35 17.7 15.59C17.77 15.87 17.91 16.13 18.04 16.41C18.05 16.29 18.02 16.2 18.13 16.16C18.2 16.14 18.26 16.19 18.28 16.27C18.29 16.32 18.28 16.39 18.23 16.42C18.18 16.45 18.12 16.42 18.03 16.39V16.38Z"
        fill="white"
      />
      <path
        d="M21.1 19.84C21.03 19.97 20.69 20.61 20.67 20.55L20.44 20.92C20.44 20.92 20.44 20.98 20.46 21C20.43 21 20.38 20.97 20.36 20.95C20.34 20.93 20.35 20.86 20.36 20.83C20.55 20.54 20.74 20.27 20.91 19.97L21.31 19.27L21.19 19.58L21.33 19.35C21.27 19.52 21.2 19.66 21.1 19.83V19.84Z"
        fill="white"
      />
      <path
        d="M14.77 15.83C14.51 16.23 14.3 16.62 14.13 17.07C14.08 17.11 14 17.12 13.94 17.13L13.56 17.22L13.71 17.14C13.71 17.14 13.71 17.07 13.7 17.07H13.54C13.93 16.92 13.98 17 14.18 16.62C14.35 16.31 14.53 16.02 14.74 15.74L14.91 15.5L14.68 15.89C14.68 15.89 14.73 15.85 14.77 15.83Z"
        fill="white"
      />
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_3460_1061"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(18.2643 18.359) rotate(-58.1048) scale(4.21196 4.36931)">
        <stop stopColor="white" />
        <stop offset={1} stopColor="#9E7DCB" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_3460_1061"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(6.0251 -8.60579 -9.19796 -6.38745 16.3416 15.3469)"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="white" />
        <stop offset={1} stopColor="#BC8CFF" />
      </radialGradient>
      <clipPath id="clip0_3460_1061">
        <rect width={24} height={24} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
